import React from 'react';

// ─────────────────────────────────────────────
// Error type → user friendly message mapper
// ─────────────────────────────────────────────
const getErrorInfo = (message = '') => {
  const msg = message.toLowerCase();

  if (msg.includes('tenant_not_found') || msg.includes('host_url') || msg.includes('tenant_error')) {
    return {
      code: '404',
      title: 'Host Not Found',
      description: 'This application URL is not registered in our system. Please make sure you are using the correct link Or Server side issue ',
    };
  }

  if (msg.includes('token_missing') || msg.includes('token_parse') || msg.includes('token_request_failed') || msg.includes('token_refresh_failed')) {
    return {
      code: 'AUTH',
      title: 'Token Not Generated',
      description: 'We were unable to generate an access token. Please refresh the page. If the issue continues, contact support.',
    };
  }

  if (msg.includes('network_error')) {
    return {
      code: 'NET',
      title: 'No Internet Connection',
      description: 'Could not reach the server. Please check your internet connection and try again.',
    };
  }

  if (msg.includes('tenant_config_fetch_failed') || msg.includes('tenant_config_empty')) {
    return {
      code: '404',
      title: 'Configuration Not Found',
      description: 'Application configuration could not be loaded. Please contact your administrator.',
    };
  }

  if (msg.includes('branches_fetch_failed')) {
    return {
      code: '500',
      title: 'Failed to Load Branches',
      description: 'Branch data could not be fetched from the server. Please refresh the page or try again later.',
    };
  }

  // Generic fallback
  return {
    code: 'ERR',
    title: 'Something Went Wrong',
    description: message || 'An unexpected error occurred. Please refresh the page.',
  };
};

// ─────────────────────────────────────────────
// ErrorPage Component
// ─────────────────────────────────────────────
export default function ErrorPage({ message }) {
  const { code, title, description } = getErrorInfo(message);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.codeBox}>
          <span style={styles.codeText}>{code}</span>
        </div>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.description}>{description}</p>
        <button
          style={styles.button}
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// Styles
// ─────────────────────────────────────────────
const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: '24px',
    fontFamily: 'sans-serif',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '48px 40px',
    maxWidth: '480px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  },
  codeBox: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FEE2E2',
    borderRadius: '12px',
    padding: '10px 24px',
    marginBottom: '24px',
  },
  codeText: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#DC2626',
    letterSpacing: '2px',
  },
  title: {
    fontSize: '22px',
    fontWeight: '600',
    color: '#111827',
    margin: '0 0 12px 0',
  },
  description: {
    fontSize: '15px',
    color: '#6B7280',
    lineHeight: '1.7',
    margin: '0 0 32px 0',
  },
  button: {
    backgroundColor: '#111827',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 28px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
  },
};